import { render, staticRenderFns } from "./CrossInfectionReminder.vue?vue&type=template&id=f0815a9c&scoped=true&"
import script from "./CrossInfectionReminder.vue?vue&type=script&lang=js&"
export * from "./CrossInfectionReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0815a9c",
  null
  
)

export default component.exports